import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, MuiLab, TextField } from 'components';

function OrderSourceChannelFilter({
  multiple,
  selectedValue,
  onSelect,
  sellerSlug,
  ...otherProps
}) {
  const options = [
    { value: 'api', label: 'API' },
    { value: 'e-commerce', label: 'E-commerce' },
    { value: 'institution-contract', label: 'Mensalidade escolar' },
    { value: 'payment-link', label: 'Link de pagamento' },
    { value: 'seller-panel', label: 'Painel do vendedor' },
    { value: 'sale-agreement', label: 'Acordo de vendas' },
  ];
  if (sellerSlug === 'eskolare') {
    options.push({ value: 'platform-billing', label: 'Cobranças da plataforma' });
  }

  const handleTypeFilter = (event, selectedOption) =>
    onSelect(
      !multiple ? selectedOption?.value : selectedOption?.map(option => option.value).join(','),
    );

  const selectedValues = !multiple
    ? options.find(option => option?.value === selectedValue) || null
    : options.filter(option => selectedValue?.split(',').includes(option?.value));

  return (
    <MuiLab.Autocomplete
      multiple={multiple}
      size="small"
      options={options}
      limitTags={3}
      value={selectedValues}
      getOptionLabel={option => option?.label || ''}
      getOptionSelected={(option, value) => option?.value === value?.value}
      onChange={handleTypeFilter}
      renderOption={(option, { selected }) => (
        <Mui.Grid container spacing={1} wrap="nowrap" alignItems="center">
          {multiple && (
            <Mui.Grid item>
              <Mui.Checkbox checked={selected} />
            </Mui.Grid>
          )}
          <Mui.Grid item xs>
            {option?.label}
          </Mui.Grid>
        </Mui.Grid>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Mui.Chip size="small" label={option?.label} {...getTagProps({ index })} />
        ))
      }
      renderInput={inputParams => (
        <TextField {...inputParams} label="Canal de origem" margin="none" size="small" />
      )}
      {...otherProps}
    />
  );
}

OrderSourceChannelFilter.propTypes = {
  multiple: PropTypes.bool,
  selectedValue: PropTypes.string,
  sellerSlug: PropTypes.string,
  onSelect: PropTypes.func,
};

export default OrderSourceChannelFilter;
